import React from 'react';
import brasaoRs from '../../../assets/logo/brasao_rs@2x.png';
import logoDefesaCivil from '../../../assets/logo/logo_defesa_civil_rs.png';
import { FooterStyle } from './footer.style';

const Footer = () => (
	<FooterStyle>
		<img className='ml-2' alt='brasao' src={brasaoRs} />
		<span className='pl-4'>Casa Militar Defesa Civil</span>
		<img className='ml-4' alt='defesaCivil' src={logoDefesaCivil} />
	</FooterStyle>
);

export default Footer;
